import { useMemo } from 'react'
import { useSafePush } from '@omnea-app/fe-routing/useSafePush'
import { DataGridBase } from '@omnea-app/fe-tables/data-grid/DataGridBase'
import { DEFAULT_SORT_MODEL } from '../dashboard-table/sortRows'
import { RfxRow, useRfxColumns } from './useRfxColumns'

const TOP_SLICE = 4

const isSelectedColumn = (columnName: string, visibleColumns: string[]) => {
  return visibleColumns.includes(columnName)
}

interface Props {
  rows: RfxRow[]
}

export const RfxDataGrid = ({ rows }: Props) => {
  const { safeUrlPush } = useSafePush()
  const rfxColumns = useRfxColumns({ sortable: false })

  const onRowClick = (requestId: string | number) => {
    void safeUrlPush(`/requests/detail/${requestId}/rfx`)
    return
  }

  const visibleColumns = ['requestName', 'status', 'dueDate']

  const columns = rfxColumns.filter((column) => isSelectedColumn(column.field, visibleColumns))
  const topRows = useMemo(() => rows.slice(0, TOP_SLICE), [rows])

  return (
    <DataGridBase
      isDefaultToolbarHidden
      disableColumnResize
      rows={topRows}
      hideFooter
      columns={columns.map((column) => ({ ...column, flex: 0.25, minWidth: 160 }))}
      onRowClick={(row) => onRowClick(row.id)}
      defaultSortModel={DEFAULT_SORT_MODEL}
      sx={{
        backgroundColor: 'none',
      }}
    />
  )
}
